import React, { useEffect, useMemo, useState } from "react";
import { Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { getAllOutlet } from "../../services/contractorApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import ActionButtons from "../../components/DataTable/ActionButtons";
import CustomTable from "../../components/DataTable/CustomTable";
import TableHeader from "../../components/DataTable/TableHeader";
import { UserPlus } from "lucide-react";
import { toast } from "react-toastify";
import { selectUser } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import { RotateCcw } from "lucide-react";
import { serialNumber } from "../../utils/helper";
import { canAct } from "../../utils/menuNodes";
import ConfirmAlert from "../../components/ConfirmAlert";
import { UserDetail } from "../../components/ItemDetail";
import DynamicFilter from "../../components/DynamicFilter/DynamicFilter";
import { getOutletDropdownData , ReactivateFuelStationRejected } from "../../services/contractorApi";
import { Toast } from "react-bootstrap";
const RejectedOutlet = ({ checkPermission }) => {
  const columnHelper = createColumnHelper();
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [search, setSearch] = useState("");
  const [searchParams] = useSearchParams();
  const pageNo = searchParams.get("pageNo") || 1;
  const pageSize = searchParams.get("pageSize") || 10;
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector(selectUser);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showDelete, setShowDelete] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [outletId, setOutletId] = useState("");
  const [filters, setFilters] = useState({});
     const [reActiveId, setReActiveId] = useState("");
      const [showAlert, setShowAlert] = useState(false);

  const [dropdownOptions, setDropdownOptions] = useState({
    energy_company_id: [],
    outlet_id: [],
    customer_code: [],
    regional_office_id: [],
    outlet_name: [],
    zone_id: [],
    sales_area_id: [],
    district_id: [],
    category: [],
    location: [],
  });

  const fetchOutletAllData = async (customFilter = {}) => {
    const status = 3;
    const payload = {
      search,
      pageSize,
      pageNo,
      status,
      ...filters,
      ...customFilter,
    };

    const res = await getAllOutlet(payload);

    setIsLoading(true);
    if (res.status) {
      setRows(res.data);
      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const getDropdowndata = async () => {
    const outlet_id = rows.map((c) => c.id).filter(Boolean);
    const energy_company_id = rows
      .map((c) => c.energy_company_id)
      .filter(Boolean);
    const zone_id = rows.map((c) => c.zone_id).filter(Boolean);
    const district_id = rows.map((c) => c.district_id).filter(Boolean);
    const sales_area_id = rows.map((c) => c.sales_area_id).filter(Boolean);

    const payload = {
      status: 3,
    };


    const dropdownres = await getOutletDropdownData(payload);

    if (dropdownres.status) {
      const data = dropdownres.data;

    
      if (dropdownres.status) {
        const data = dropdownres.data;
        console.log(data?.outlets);
        setDropdownOptions({
          energy_company_name:
            data?.energy_company_name?.map((item) => ({
              value: item.energy_company_id,
              label: item.energy_company_name,
            })) || [],
          outlet_id:
            data?.outlets?.map((item) => ({
              value: item.outlet_unique_id,
              label: item.outlet_unique_id,
            })) || [],
            outlet_name:
            data?.outlets?.map((item) => ({
              value: item.outlet_name,
              label: item.outlet_name,
            })) || [],
          customer_code:
            data?.customer_code?.map((item) => ({
              value: item.customer_code,
              label: item.customer_code,
            })) || [],
          ro_name:
            data?.regional_office?.map((item) => ({
              value: item.regional_office_id,
              label: item.regional_office_name,
            })) || [],
       
        
          zone:
            data?.zone_name?.map((item) => ({
              value: item.zone_id,
              label: item.zone_name,
            })) || [],
          sales_area_id:
            data?.sales_area?.map((item) => ({
              value: item.id,
              label: item.sales_area_name,
            })) || [],
          district:
            data?.district?.map((item) => ({
              value: item.id,
              label: item.district_name,
            })) || [],
          category:
            data?.category?.map((item) => ({
              value: item.outlet_category,
              label: item.outlet_category,
            })) || [],
          location:
            data?.location?.map((item) => ({
              value: item.location,
              label: item.location,
            })) || [],
        });
      }
    }
  };
  useEffect(() => {
    fetchOutletAllData();
  }, [search, pageNo, pageSize]);
  useEffect(() => {
 
      getDropdowndata();
    
  }, []);
  const fields = [
    {
      key: "energy_company_id",
      label: "Energy Company ",
      value: filters.energy_company_id,
      options: dropdownOptions.energy_company_name,

      type: "select",
    },
      {
      key: "zone_id",
      label: "Zone",
      value: filters.zone_id,
      options: dropdownOptions.zone,
      type: "select",
    },
      {
      key: "regional_office_id",
      label: "Regional Office",
      value: filters.regional_office_id,
      options: dropdownOptions.ro_name,
      type: "select",
    },
 
    
    {
      key: "sales_area_id",
      label: "Sales Area",
      value: filters.sales_area_id,
      options: dropdownOptions.sales_area_id,
      type: "select",
    },
       {
      key: "district_id",
      label: "District",
      value: filters.district_id,
      options: dropdownOptions.district,
      type: "select",
    },
  
    {
      key: "outlet_name",
      label: "Outlet ",
      value: filters.outlet_name,
      options: dropdownOptions.outlet_name,
      type: "select",
    },
   {
      key: "outlet_id",
      label: "Outlet Id",
      value: filters.outlet_id,
      options: dropdownOptions.outlet_id,
      type: "select",
    },
    {
      key: "customer_code",
      value: filters.customer_code,
      label: "Customer Code",
      options: dropdownOptions.customer_code,
      type: "select",
    },
  
 


    {
      key: "category",
      label: "Category",
      value: filters.category,
      options: dropdownOptions.category,
      type: "select",
    },
    {
      key: "location",
      label: "Location",
      value: filters.location,
      options: dropdownOptions.location,
      type: "select",
    },
    {
      key: "fromDate",
      label: "From Date",

      type: "date",
    },
    {
      key: "toDate",
      label: "To Date",
      type: "date",
    },
  ];
     const handleReActive = async () => {
        const res = await ReactivateFuelStationRejected(reActiveId);
        if (res.status) {
          toast.success(res.message);
          setRows((prev) => prev.filter((itm) => itm.company_id !== +reActiveId));
        fetchOutletAllData()
        } else {
          toast.error(res.message);
        }
        setReActiveId("");
        setShowAlert(false);
      };
  const handleFilterChange = async (key, value) => {
    const updatedFilters = {
      ...filters,
      [key]: value,
    };
    setFilters(updatedFilters);
    await fetchOutletAllData({ [key]: value });
  };

  const columns = useMemo(
    () => [
      columnHelper.accessor("sr_no", {
        header: t("Sr No."),
        cell: (info) => {
          const serialNumbers = serialNumber(pageNo, pageSize);
          return serialNumbers[info.row.index];
        },
      }),
      columnHelper.accessor("outlet_name", {
        header: "outlet Id ",
      }),
      columnHelper.accessor("energy_company_name", {
        header: "energy company ",
      }),
      columnHelper.accessor("zone_name", {
        header: "zone ",
      }),
      columnHelper.accessor("regional_office_name", {
        header: "regional office ",
      }),
      columnHelper.accessor("sales_area_name", {
        header: "sales area ",
      }),
      columnHelper.accessor("district_name", {
        header: "district ",
      }),
      columnHelper.accessor("outlet_unique_id", {
        header: "outlet unique id",
      }),
      columnHelper.accessor("outlet_category", {
        header: "outlet category",
      }),
             columnHelper.accessor("customer_code", {
        header: "Customer Code ",
      }),
       columnHelper.accessor("location", {
        header: "Location ",
      }),
      // columnHelper.accessor("created_by", {
      //   header: t("Created By"),
      //   cell: (info) => (
      //     <UserDetail
      //       img={info.row.original?.created_by?.image}
      //       name={info.row.original?.created_by?.name}
      //       id={info.row.original?.created_by?.id}
      //       unique_id={info.row.original?.created_by?.employee_id}
      //       login_id={user.id}
      //     />
      //   ),
      // }),
      columnHelper.accessor("action", {
        header: "Action",
        cell: (info) => (
        
          <ActionButtons
                    actions={{
                      view: {
                        show: checkPermission?.view,
                        action: () =>
                                  navigate(`/outlet/create/${info.row.original.id}?type=view`),
                      },
                      reject: {
                        show: canAct(checkPermission, "reactivate"),
                        icon: RotateCcw,
                        tooltipTitle: "Re-Active",
                        align: "left",
                        action: () => {
                          setReActiveId(info.row.original.id);
                          setShowAlert(true);
                        },
                      },
                    }}
                  />
        ),
      }),
    ],
    [checkPermission, t, rows.length, pageNo, pageSize]
  );

  return (
    <>
      <Helmet>
        <title>Outlet Management · CMS Electricals</title>
      </Helmet>
      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <DynamicFilter fields={fields} onChange={handleFilterChange} />
        <CustomTable
          id={"rejected_outlet"}
          userPermission={checkPermission}
          isLoading={isLoading}
          rows={rows || []}
          columns={columns}
          pagination={{
            pageNo,
            pageSize,
            totalData,
          }}
          customHeaderComponent={() => (
            <TableHeader
              userPermission={checkPermission}
              setSearchText={setSearch}
              button={{ show: false }}
            />
          )}
          tableTitleComponent={
            <div>
              <UserPlus /> <strong>rejected outlet</strong>
            </div>
          }
        />
      </Col>
           <ConfirmAlert
                    size={"sm"}
                    deleteFunction={handleReActive}
                    hide={setShowAlert}
                    show={showAlert}
                    title={"Confirm Re-Active"}
                    description={"Are you sure you want to re-active this!!"}
                  />
    </>
  );
};

export default RejectedOutlet;
